/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesContactResponseDto } from '../../models/sales-contact-response-dto';
import { SalesContactUpdateDto } from '../../models/sales-contact-update-dto';

export interface ContactsControllerUpdate$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the contact to update.
 */
  id: string;
      body: SalesContactUpdateDto
}

export function contactsControllerUpdate(http: HttpClient, rootUrl: string, params: ContactsControllerUpdate$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContactResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, contactsControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesContactResponseDto>;
    })
  );
}

contactsControllerUpdate.PATH = '/o2-sales/contacts/{tenant}/{id}';
